const languageLookup = {
  default: "Default",
	af: "Afrikaans",
	am: "Amharic",
	ar: "Arabic",
	az: "Azerbaijani",
	be: "Belorussian",
	bg: "Bulgarian",
	bn: "Bengali",
	br: "Breton",
	bs: "Bosnian",
	ca: "Catalan",
	cs: "Czech",
	cy: "Cymraeg",
	da: "Danish",
	de: "German",
	dv: "Dhivehi",
	en: "English",
	es: "Spanish",
	et: "Estonian",
	eu: "Basque",
	fa: "Persian",
	fi: "Finnish",
	fr: "French",
	ga: "Irish",
	gl: "Galician",
	el: "Greek",
	ha: "Hausa",
	he: "Hebrew",
	hi: "Hindi",
	hr: "Croatian",
	hu: "Hungarian",
	hy: "Armenian",
	is: "Icelandic",
	it: "Italian",
	id: "Indonesian",
	ja: "Japanese",
	ka: "Georgian",
	kk: "Kazakh",
	km: "Khmer",
	ko: "Korean",
	ku: "Kurdish",
	ky: "Kyrgyz",
	lt: "Lithuanian",
	lv: "Latvian",
	mk: "Macedonian",
	ml: "Malayalam",
	mn: "Mongolian",
	mr: "Marathi",
	ms: "Malay",
	mt: "Maltese",
	nb: "Norwegian Bokmål",
	nl: "Dutch",
	nn: "Norwegian Nynorsk",
	no: "Norwegian",
	pl: "Polish",
	ps: "Pashto",
	pt: "Portuguese",
	ro: "Romanian",
	ru: "Russian",
	sd: "Sindhi",
	sk: "Slovak",
	sl: "Slovene",
	so: "Somali",
	sq: "Albanian",
	sr: "Serbian",
	sv: "Swedish",
	sw: "Swahili",
	ta: "Tamil",
	tg: "Tajik",
	th: "Thai",
	tk: "Turkmen",
	tr: "Turkish",
	tt: "Tatar",
	ug: "Uyghur",
	uk: "Ukrainian",
	ur: "Urdu",
	uz: "Uzbek",
	zh: "Chinese",
	vi: "Vietnamese"
}

export default languageLookup;
